import { EyeOutlined, PictureOutlined } from "@ant-design/icons";
import { Space, Tooltip } from "antd";
import { useHistory } from "react-router";
import { formatDate } from "../../../../utils/formatDate";

////
export default function useColums() {
  const history = useHistory();

  const handleClick = ({ campaniaID, clienteID }) =>
    history.push(`/clientes/detalleCampania/${clienteID}/${campaniaID}`);

  const handleMaterialesClick = ({ campaniaID, clienteID }) =>
    history.push(`/clientes/detalleCampania/${clienteID}/${campaniaID}/materiales`);

  const campaniasColumns = [
    {
      title: "Nombre",
      dataIndex: "nombre",
    },
    {
      title: "Prefijo de ID",
      dataIndex: "abreviatura",
    },
    {
      title: "Afiliados Proyectados",
      dataIndex: "afiliadosProyectados",
    },
    {
      title: "Inicio",
      render: (text, record) => formatDate(record.fechaInicio),
    },
    {
      title: "Vencimiento",
      render: (text, record) => formatDate(record.fechaVencimiento),
    },

    {
      title: "Esta Activa",
      width: 150,
      render: (text, record) => (
        <>{record.estaActiva ? <span>Si</span> : <span>No</span>}</>
      ),
    },
    {
      title: "",
      width: 70,
      render: (text, record) => (
        <Space>
          <Tooltip title="Abrir campaña">
            <EyeOutlined
              onClick={() => handleClick(record)}
              style={{ color: "#ca2228" }}
              className="eyeIcon"
            />
          </Tooltip>
          <Tooltip title="Materiales">
            <PictureOutlined
              onClick={() => handleMaterialesClick(record)}
              style={{ color: "#ca2228" }}
              className="eyeIcon"
            />
          </Tooltip>
        </Space>
      ),
    },
  ];

  return { campaniasColumns };
}
